import './overscroll';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import Spinner from 'shared/components/misc/simpleSpinner.jsx';
import Footer from './components/layout/footer';
import { Navigation, Router, Route, Redirect } from 'react-router';
import { history } from 'react-router/lib/BrowserHistory';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import PrintableCuesheetActions from 'flux/actions/cuesheet.printable/PrintableCuesheetActions';
import UserActions from 'flux/actions/UserActions';
import RouteActions from 'flux/actions/RouteActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import IntercomSessionStore from 'flux/stores/IntercomSessionStore';
/* eslint-disable no-unused-vars */
import SocketChannelStore from 'flux/stores/SocketChannelStore';
import OnlineIndicatorStore from 'flux/stores/OnlineIndicatorStore';
import UserStore from 'flux/stores/UserStore';
/* eslint-enable no-unused-vars */
import Confirm from 'shared/components/misc/confirm.jsx';
import Alert from 'shared/components/misc/alert.jsx';
import { Managed as AlertBar } from 'shared/components/misc/alertBar.jsx';
import PendingReadOnlyAlertBar from 'main/components/event/pendingReadOnlyAlertBar.jsx';
import ReadOnlyAlertBar from 'shared/components/misc/readOnlyAlertBar.jsx';
import TemplateAlertBar from 'main/components/show/templateAlertBar.jsx';
import ToastList from 'shared/components/misc/toastList.jsx';
import { Grid } from 'bootstrap';
import CellAssetModal from 'main/components/event/cellAssetModal.jsx';
import CellLinkModal from 'main/components/event/cellLinkModal.jsx';
import GuestPassModalContainer from 'main/components/event/guestPassModalContainer.jsx';
import GlobalElementsGuestPassModalContainer from 'main/components/event/globalElementsGuestPassModalContainer.jsx';
import ExportModal from 'main/components/show/exportModal.jsx';
import ExportPDFModalV3 from 'main/components/show/exportPDFModalV3.jsx';
import KeyboardShortcutsModal from 'main/components/show/keyboardShortcutModal.jsx';
import InsertGlobalElementsModal from 'main/components/show/cuesheet.globalElement/insertGlobalElementsModal.jsx';
import WordExportModal from 'main/components/show/wordExportFormModal.jsx';
import GlobalElementsActivationModal from 'shared/components/team/globalElementsActivationModal.jsx';
import TeleprompterActivationModal from 'shared/components/misc/teleprompterActivationModal.jsx';
import NewGlobalElementModal from 'main/components/show/newGlobalElementModal.jsx';
import EventDeletedErrorModal from 'main/components/event/deletedErrorModal.jsx';
import UpgradeAlertModal from 'shared/components/misc/upgradeAlertModal.jsx';
import PublishGlobalElementsChangesModal from 'main/components/show/cuesheet.globalElement/publishGlobalElementsChangesModal.jsx';
import CreatePDFPresetModal from 'main/components/show/cuesheet.printable/pdfExportForm/createPDFPresetModal.jsx';
import DisplayViewModal from 'main/components/show/cuesheet.displayView/displayViewModal.jsx';
import RemoteTeleprompterModal from 'main/components/show/remoteTeleprompterModal.jsx';
import MaintenanceCurtain from 'shared/components/misc/maintenanceCurtain';
import PermissionActions from 'flux/actions/PermissionActions';
import CustomDragLayer from 'main/components/misc/dragLayer';
import PendoContainer from 'main/components/misc/PendoContainer.jsx';
import { ViewTypes, ViewRelativePaths } from 'shared/constants/CuesheetViews';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import classNames from 'classnames';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';

import mobileCheck from 'shared/lib/mobileCheck';
import { isIE } from 'shared/lib/browserCheck';
import { initDataDog, addDataDogUserContext } from 'shared/lib/datadog';
import addTimezones from 'shared/lib/addTimezones';

import '@shoflo-rundown/fixed-data-table/dist/fixed-data-table.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'style/main';
import 'main/app.init.js';

/**
 * Page imports
 */
import GridPage from 'main/pages/event/grid.jsx';
import ShowDesktopPage, {
  CompactCuesheetPage,
  GlobalElementCuesheetPage,
} from 'main/pages/event/show.jsx';
import FeaturedCuesheetPage from 'main/pages/event/showFeatured.jsx';
import DisplayViewPage from 'main/pages/event/displayView.jsx';
import Teleprompter from 'main/pages/event/teleprompter.jsx';
import ShowResponsivePage from 'main/pages/event/show.responsive.jsx';
import PrintableShow from 'main/pages/event/printableShow.jsx';
import ShowTemplateListPage from 'main/pages/event/showTemplateList';
import GuestPassShow from 'main/pages/event/guestPassShow.jsx';
import GuestPassEvent from 'main/pages/event/guestPassEvent.jsx';
import EventDocPage from 'main/pages/event/eventDocPage.jsx';

addTimezones();

const isMobile = mobileCheck();

/**
 * Main App component
 */
const App = React.createClass({
  mixins: [
    Navigation,
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(IntercomSessionStore, 'intercom'),
    Reflux.listenTo(
      UserActions.loadFromSession.failed,
      'onLoadFromSessionFailed',
    ),
    Reflux.listenTo(
      UserActions.loadFromSession.completed,
      'onLoadFromSessionCompleted',
    ),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  childContextTypes: {
    user: React.PropTypes.object,
  },

  getChildContext() {
    return { user: this.state.user };
  },

  displayName: 'MainApp',

  render() {
    const { user } = this.state;
    const { children, params } = this.props;
    const { showId, eventId } = params;

    return (
      <div>
        <PendoContainer />
        <ExportPDFModalV3 />
        <AlertBar />
        {showId ? <TemplateAlertBar /> : null}
        {eventId ? <ReadOnlyAlertBar /> : null}
        {eventId ? <PendingReadOnlyAlertBar /> : null}
        <Grid fluid className={classNames('flex-container')}>
          <div>
            <Confirm />
            <MaintenanceCurtain />
            <Alert />
            <ToastList />
            <CustomDragLayer />
            {/* Global Modals */}
            <EventDeletedErrorModal />
            <UpgradeAlertModal />
            <CellAssetModal />
            <CellLinkModal />
            <GuestPassModalContainer />
            <GlobalElementsGuestPassModalContainer />
            <WordExportModal />
            <ExportModal />
            <KeyboardShortcutsModal />
            <InsertGlobalElementsModal />
            <NewGlobalElementModal />
            <PublishGlobalElementsChangesModal />
            <CreatePDFPresetModal />
            <DisplayViewModal />
            <RemoteTeleprompterModal />
            <GlobalElementsActivationModal />
            <TeleprompterActivationModal />
          </div>
          <div
            className={classNames('flex-container', 'flex-row', 'flex-stretch')}
          >
            <div className={classNames('main-dash-flex', 'flex-container')}>
              {user || this._isPublic() ? (
                children
              ) : (
                <Spinner top="50%" left="50%" />
              )}
            </div>
          </div>
          <Footer packageVersion={window.globals.packageVersion} />
        </Grid>
      </div>
    );
  },

  onLoadFromSessionFailed(err) {
    console.log('load user from session failed');
    console.log(err);

    if (!this._isPublic()) {
      //routing to logout will clear the user's access token then redirect to login
      UserActions.logout();
    }
  },

  onLoadFromSessionCompleted(user) {
    addDataDogUserContext(user);
  },

  _isPublic() {
    return this._isPublicPage() || this._isPublicDocPage();
  },

  _isPublicPage() {
    return window.location.href.indexOf('guest') !== -1;
  },

  _isPublicDocPage() {
    return this.context.router.state.params.docId !== undefined;
  },

  _forceUpdate() {
    this.forceUpdate();
  },

  componentWillMount() {
    const { location } = window;
    const isGuest = location.href.indexOf('guest') !== -1;
    if (isIE() && !isGuest) {
      window.location.href = '/unsupported/ie';
    }
    /**
     * Get permission names from permission store
     */
    PermissionActions.populateNames();

    const { params } = this.props;

    initDataDog(params);
  },

  componentDidMount() {
    /**
     * this listener is to make sure that the app updates when
     * a mobile/phone is rotated or screen is resized
     */
    window.addEventListener('resize', this._forceUpdate);

    /**
     * Events
     */
    RouteActions.goToEventCrew.listen((params) => {
      window.location.assign(
        `/dash/team/${params.teamId}/event/${params.eventId}/crew`,
      );
    });

    RouteActions.goToEvent.listen((params) => {
      window.location.assign(
        `/dash/team/${params.teamId}/event/${params.eventId}`,
      );
    });

    //Only used for proper routing to team show templates page in app.dash
    RouteActions.goToTeamTemplates.listen((params) => {
      window.location.assign(`/dash/team/${params.teamId}/templates`);
    });

    //Only used for proper routing to team global elements page in app.dash
    RouteActions.goToTeamGlobalElements.listen((params) => {
      window.location.assign(`/dash/team/${params.teamId}/elements`);
    });

    /**
     * Shows
     */
    function _getShowBasePath(params) {
      return `/teams/${params.teamId}/events/${params.eventId}/shows/${params.showId}`;
    }

    RouteActions.goToGlobalElementManager.listen((params) => {
      CuesheetRowActions.bustRowHeightCache();
      CuesheetActions.clear();
      PrintableCuesheetActions.clear();

      const path = _getShowBasePath(params);

      this.transitionTo(`${path}/${ViewRelativePaths.GlobalElement}`);
    });

    RouteActions.goToTeleprompter.listen((params, query) => {
      const { rowId, columnId } = params;
      const showPath = _getShowBasePath(params);

      let queryString = '?';

      queryString += `zoom=${query.zoom}&`;
      queryString += `lineHeight=${query.lineHeight}&`;
      queryString += `fontWeight=${query.fontWeight}&`;
      queryString += `capitalization=${query.capitalization}&`;
      queryString += `singleItem=${query.singleItem}&`;
      queryString += `itemInfo=${query.itemInfo}&`;
      if (query.displaySplash) {
        queryString += `displaySplash=${query.displaySplash}`;
      }

      this.transitionTo(
        `${showPath}/rows/${rowId}/columns/${columnId}/${ViewRelativePaths.Teleprompter}${queryString}`,
      );
    });

    RouteActions.goToRemoteTeleprompter.listen((params, query) => {
      const { rowId, columnId } = params;
      const showPath = _getShowBasePath(params);
      window.open(
        `${showPath}/rows/${rowId}/columns/${columnId}/${ViewRelativePaths.RemoteTeleprompter}?${query}`,
      );
    });

    RouteActions.goToTeleprompterInitialization.listen((params) => {
      const showPath = _getShowBasePath(params);
      this.transitionTo(`${showPath}/${ViewRelativePaths.Teleprompter}`);
    });

    RouteActions.goToFeaturedFromTeleprompter.listen((params) => {
      //We don't clear the cuesheet here because it's the same show
      CuesheetRowActions.bustRowHeightCache();

      this.transitionTo(
        `${_getShowBasePath(params)}/${ViewRelativePaths.Featured}`,
      );
    });

    RouteActions.goToShow.listen((params) => {
      CuesheetActions.clear();
      FullScreenCuesheetActions.clear(params);
      PrintableCuesheetActions.clear();
      PDFExportFormActions.clear();

      //When navigating to a show we need to refresh the row heights
      CuesheetRowActions.bustRowHeightCache();

      let path = _getShowBasePath(params);
      const { user } = this.state;
      const cuesheetView = user.getIn(['preferences', 'cuesheetView']);

      let showView = `/${ViewRelativePaths.Loose}`;

      if (cuesheetView === ViewTypes.Compact) {
        showView = `/${ViewRelativePaths.Compact}`;
      } else if (cuesheetView === ViewTypes.Featured) {
        showView = `/${ViewRelativePaths.Featured}`;
      }

      /**
       * If it's a mobile user agent, we need to change the URL accordingly
       */

      if (params.relativePath) {
        path += '/' + params.relativePath;
      } else if (isMobile || this.props.params.displayMode) {
        path += '/responsive/' + (this.props.params.displayMode || 'table');
      } else {
        path += showView;
      }

      /**
       * Reload permissions when we go to the cuesheet...
       * this refetches the user+permissions in the event that they have created new teams, etc since the last time they visited a cuesheet
       */
      UserActions.loadFromSession();

      this.transitionTo(path);
    });

    RouteActions.goToShowByTracking.listen((params) => {
      /**
       * Do not follow tracking if the user happens to be on the home screen, or somewhere other than a show route.
       */
      const routeParams = this.context.router.state.params;
      if (!routeParams.showId) return;

      RouteActions.goToShow(params);
    });

    RouteActions.toggleMobileDisplayMode.listen((params, displayMode) => {
      UserActions.loadFromSession();

      this.transitionTo(
        _getShowBasePath(params) + `/responsive/${displayMode}`,
      );
    });

    RouteActions.goToGrid.listen((params) => {
      CuesheetActions.clear();
      PDFExportFormActions.clear();
      PrintableCuesheetActions.clear();

      const path = _getShowBasePath(params) + '/grid';

      /**
       * If it's a mobile user agent, we need to change the URL accordingly
       */

      /**
       * Reload permissions when we go to the cuesheet...
       * this refetches the user+permissions in the event that they have created new teams, etc since the last time they visited a cuesheet
       */
      UserActions.loadFromSession();

      this.transitionTo(path);
    });

    /**
     * Go to proper route based on show displayType
     */
    RouteActions.goToShowDisplayType.listen((params, displayType) => {
      if (displayType === DisplayTypes.show || !displayType) {
        RouteActions.goToShow(params);
      } else {
        RouteActions.goToGrid(params, displayType);
      }
    });

    RouteActions.goToDisplayView.listen((params) => {
      FullScreenCuesheetActions.clear(params);

      const path = `${_getShowBasePath(params)}/desktop/display`;

      /**
       * Reload user permissions/settings when going to display view
       */
      UserActions.loadFromSession();

      this.transitionTo(path);
    });

    /**
     * Users
     */
    RouteActions.goToUserDash.listen(() =>
      window.location.replace(`/dash/user`),
    );

    /**
     * Teams
     */
    RouteActions.goToTeamDash.listen((params) => {
      if (params.tabId === 6) {
        return window.location.replace(`/dash/team/${params.teamId}/elements`);
      }
      window.location.replace(`/dash/team/${params.teamId}`);
    });

    /**
     * General/misc pages
     */
    RouteActions.goToLearn.listen(() => this.transitionTo('/learn')); //This link will route outside of our app.

    /**
     * Guest pass pages
     */
    RouteActions.goToShowForGuest.listen((params) => {
      window.location.href = `/teams/${params.teamId}/events/${params.eventId}/shows/${params.showId}/guest`;
    });
    RouteActions.goToEventForGuest.listen(
      (params) =>
        (window.location.href =
          '/teams/' + params.teamId + '/events/' + params.eventId + '/guest'),
    );
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this._forceUpdate);
  },
});

const DNDApp = DragDropContext(HTML5Backend)(App);

/**
 * The Router component
 *
 */
function onRouterUpdate() {
  if (window.Intercom) {
    window.Intercom('update');
  }
}

ReactDOM.render(
  <Router history={history} onUpdate={onRouterUpdate}>
    <Route component={DNDApp}>
      <Route
        path="/teams/:teamId/events/:eventId/saved"
        component={ShowTemplateListPage('saved')}
      />
      <Route
        path="/teams/:teamId/events/:eventId/saved/archived"
        component={ShowTemplateListPage('saved', true)}
      />
      <Route
        path="/teams/:teamId/events/:eventId/templates"
        component={ShowTemplateListPage('templates')}
      />
      <Route
        path="/teams/:teamId/events/:eventId/templates/archived"
        component={ShowTemplateListPage('templates', true)}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/grid"
        component={GridPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop"
        component={ShowDesktopPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop/global"
        component={GlobalElementCuesheetPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop/compact"
        component={CompactCuesheetPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop/featured"
        component={FeaturedCuesheetPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop/display"
        component={DisplayViewPage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/desktop/teleprompter"
        component={Teleprompter}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/rows/:rowId/columns/:columnId/desktop/teleprompter"
        component={Teleprompter}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/responsive/:displayMode"
        component={ShowResponsivePage}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/pdf/view/:type"
        component={PrintableShow}
      />
      <Route
        path="/teams/:teamId/events/:eventId/shows/:showId/guest"
        component={GuestPassShow}
      />
      <Route
        path="/teams/:teamId/events/:eventId/guest"
        component={GuestPassEvent}
      />
      <Route
        path="/teams/:teamId/events/:eventId/doc/:docId"
        component={EventDocPage}
      />

      <Redirect
        from="/teams/:teamId/events/:eventId/new"
        to="/teams/:teamId/events/:eventId"
      />
      <Route
        path="*"
        component={() => {
          window.location.assign('/dash/user');
          return null;
        }}
      />
    </Route>
  </Router>,
  document.getElementById('mainViewContainer'),
);

/**
 * A simple mapping of Route Action to path...only for routes w/ no params
 *
 */
const SimpleRouteMappings = {
  goToLearn: '/learn',
};

RouteActions.goToLogin.listen(function () {
  const redirectUrl = window.location.href;
  window.location.href = `/login?redirect=${encodeURIComponent(redirectUrl)}`;
});

/**
 * Apply simple route handlers
 */

Object.keys(SimpleRouteMappings).forEach((actionKey) => {
  RouteActions[actionKey].listen(function () {
    window.location.href = SimpleRouteMappings[actionKey];
  });
});

UserActions.logout.completed.listen(() => RouteActions.goToLogin());
